import { render, staticRenderFns } from "./deleteMember.vue?vue&type=template&id=45672ac0&scoped=true&"
import script from "./deleteMember.vue?vue&type=script&lang=js&"
export * from "./deleteMember.vue?vue&type=script&lang=js&"
import style0 from "./deleteMember.vue?vue&type=style&index=0&id=45672ac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45672ac0",
  null
  
)

export default component.exports